import { on } from "@ngrx/store";
import { DeveloperState } from "../developer.state";
import { EmailLogsActions } from "./email-logs.actions";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update developer state within PagesStore
// **************************************************************************

function withDeveloper(state: PagesStore, updater: (developer: DeveloperState) => DeveloperState): PagesStore {
    return { ...state, developer: updater(state.developer) };
}

// **************************************************************************
// EMAIL LOGS REDUCER (array format for PagesStore)
// **************************************************************************

const load = on(EmailLogsActions.load, (state: PagesStore) => withDeveloper(state, developerState => ({
    ...developerState,
    emailLogs: { ...developerState.emailLogs, loading: true },
    error: null,
})));

const loadSuccess = on(EmailLogsActions.loadSuccess, (state: PagesStore, { logs }) => withDeveloper(state, developerState => ({
    ...developerState,
    emailLogs: { ...developerState.emailLogs, logs, loading: false },
    error: null,
})));

const loadFailure = on(EmailLogsActions.loadFailure, (state: PagesStore, { error }) => withDeveloper(state, developerState => ({
    ...developerState,
    emailLogs: { ...developerState.emailLogs, loading: false },
    error,
})));

export const emailLogsReducer = [
    load,
    loadSuccess,
    loadFailure,
];
